
export default function NotFound() {
  return (
    <section className='flex flex-col items-center'>
      <h3 className='text-2xl font-bold mb-2'>NotFound😅</h3>
    </section>
  );
}

